// ======================================================================
// File Name       : GroupRegisterEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Button, Col } from 'react-bootstrap';
import ModalWrapper from '../../components/modal/ModalWrapper';
import GroupRegisterEdit from '../../components/group/GroupRegisterEdit';
import UserAttributeRegisterEditContainer from '../userAttribute/UserAttributeRegisterEditContainer';
import * as groupActions from '../../actions/GroupAction';
import * as modalActions from '../../actions/ModalAction';
import { MODE } from '../../constants';
import { REDIRECT_MODAL } from '../../constants/GroupConstants';

class GroupRegisterEditContainer extends Component {
  constructor() {
    super();
    this.state = {
      userAttributeExpanded: false,
    };
    this.handleUserAttributeTitleClick = this.handleUserAttributeTitleClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleNextBtn = this.handleNextBtn.bind(this);
    this.validation = this.validation.bind(this);
  }

  handleUserAttributeTitleClick() {
    this.setState({ userAttributeExpanded: !this.state.userAttributeExpanded });
  }

  handleInputChange(name, value) {
    const { dispatch } = this.props;
    dispatch(groupActions.editingGroup({ [name]: value }));
  }

  handleNextBtn() {
    if (!this.validation()) return;
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].OK));
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  getModalOptions() {
    const { group } = this.props;
    const footerBtns = [
    ];
    const OPTIONS = {
      [MODE.NEW_MODE]: {
        title: 'ユーザーグループ情報の新規登録',
        footerBtns,
      },
      [MODE.EDIT_MODE]: {
        title: 'ユーザーグループ情報の編集',
        footerBtns,
      },
    };
    return OPTIONS[group.editType];
  }

  render() {
    const { group } = this.props;
    this.refsToValidate = [];
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.props.hideModal} dialogClassName="group-detail-dialog">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            this.handleNextBtn();
          }}
          className='form-horizontal'
        >
          <GroupRegisterEdit
            groupBySecernId={group.structures.bySecernId}
            editingGroup={group.editingGroup}
            handleInputChange={this.handleInputChange}
            ref={(groupRegistEdit) => {
              if (groupRegistEdit) {
                this.refsToValidate.push(groupRegistEdit);
              }
            }}
          />
          <UserAttributeRegisterEditContainer
            titleClass="padding-left-5"
            leftClass="padding-left-30"
            expanded={this.state.userAttributeExpanded}
            onTitleClick={this.handleUserAttributeTitleClick}
          />
          <Col sm={12} className="text-center padding-top-10">
            <Button variant="default" style={{ marginRight: '5px' }} onClick={this.props.hideModal} className="btn btn-default btn-96">
              {'キャンセル'}
            </Button>
            <Button variant="primary" className="btn-96" type="button" onClick={this.handleNextBtn}>
              {'次へ'}
            </Button>
          </Col>
        </Form>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { group } = state;
  return { group };
};
export default connect(mapStateToProps)(GroupRegisterEditContainer);
